import { useCallback } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { navigateToLogbookEntry } from "src/generator/utils/navigateToLogbookEntry";
import { useDispatch, useSelector } from "src/redux/hooks";
import { refetchLogbook } from "src/redux/slices/generatorSlice";

/** Opens an entry, reloading it when New Entry left its id in the route. */
export const useOpenLogbookEntry = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [, setSearchParams] = useSearchParams();
  const { logbookId, idType, lbeidOrPartId } = useParams();
  const latestEntryId = useSelector(
    state => state.generatorSlice.latestEntry.id,
  );

  return useCallback(
    (entryId: string) => {
      if (!logbookId || !idType) return;
      navigateToLogbookEntry(
        navigate,
        setSearchParams,
        logbookId,
        idType,
        entryId,
      );
      if (
        lbeidOrPartId === entryId &&
        String(latestEntryId) !== String(entryId)
      ) {
        dispatch(refetchLogbook());
      }
    },
    [
      dispatch,
      idType,
      latestEntryId,
      lbeidOrPartId,
      logbookId,
      navigate,
      setSearchParams,
    ],
  );
};
